<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import Form from '../form';

export default {
  extends: TablePage,
  name: 'product_promotion_report_list',
  components: {
    Modal,
    Form,
  },
  data() {
    return {
      // requestType: 'GET',
      params: {
        type: 'gift',
      },
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('product_promotion_report_list');
  },
  methods: {
    // 按钮点击事件
    modalClick({ val, row }) {
      if (['view'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'Form';
        if (val.code === 'view') {
          this.modalConfig.title = '兑付明细';
        }
        this.modalConfig.width = '70%';
        this.modalConfig.height = '600px';
        this.formConfig = {
          type: val.code,
          id: row.id || '',
          code: val.code || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
